export default __webpack_public_path__ + "static/media/hht2_ep12_timeline_q02_b.aa748fec.png";